import { render, staticRenderFns } from "./GenerationFormatsExogena.vue?vue&type=template&id=95488b62&scoped=true"
import script from "./GenerationFormatsExogena.vue?vue&type=script&lang=js"
export * from "./GenerationFormatsExogena.vue?vue&type=script&lang=js"
import style0 from "./GenerationFormatsExogena.vue?vue&type=style&index=0&id=95488b62&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95488b62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95488b62')) {
      api.createRecord('95488b62', component.options)
    } else {
      api.reload('95488b62', component.options)
    }
    module.hot.accept("./GenerationFormatsExogena.vue?vue&type=template&id=95488b62&scoped=true", function () {
      api.rerender('95488b62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/taxreports/components/GenerationFormatsExogena.vue"
export default component.exports